module.exports = __webpack_public_path__ + "static/standalone/img/buyer-agreement.9be33f9e.svg";